import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import { Box, Drawer, Typography } from '@mui/material';


// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import sidebarConfig from './SidebarConfig';
import { encryptStorage } from '../../CustomStorage';
import { APP_CONSTANTS } from '../../URLConstants';
import { useAuth } from '../../components/customContextProviders/AuthContext';



// ----------------------------------------------------------------------

const DRAWER_WIDTH = 70;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
   
  },
 
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));


const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const useStyles = makeStyles({
   customDrawer:{
    marginLeft:"25px"
   }
})


// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};


export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const classes = useStyles();

  const adminData = encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_DATA);
  const {sessionUserData}=useAuth()


  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column', }
      }}
    >
      <Box sx={{ px: 2.5, py: 3,alignItems:'center', }}>
        <Box component={RouterLink} to="/dashboard/soundboxT" sx={{ display: 'inline-flex',alignItems:'center', textDecoration:'none', }}>
          <Logo sx={{width:"40px"}} img={sessionUserData?.user?.organization?.icon} />
          <Typography sx={{pl:3, color:'black',fontStyle:'bold',fontWeight:800,fontSize:'14px'}}>{sessionUserData?.user?.organization?.name}</Typography>
        </Box>
      </Box>
{/* 
      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar alt="photoURL" />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {adminData?.admin?.name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box> */}

      <NavSection loggedinUserData={sessionUserData}  navConfig={sidebarConfig} />

      {/* <Box sx={{ flexGrow: 1 }} />

      <Box sx={{
        p: 2.5,
        m: 2,
        borderRadius: 1,
        position: 'relative',
        bgcolor: 'grey.200',

      }}>
        <Box sx={{ textAlign: 'center', float: "center", display: "flex" }}>
          <img src="/static/logo.svg" alt="proxgy logo" />
          <Typography sx={{ fontSize: 12, mt: .5, ml: 2, color: "black" }}>
            Powered By Proxgy
          </Typography>

        </Box>


      </Box> */}
    </Scrollbar>
  );

  return (
    <RootStyle > 
      <MHidden width="lgUp" >
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
          className={classes.customDrawer}
        >
          {renderContent}
        </Drawer>
      </MHidden>




      <MHidden width="lgDown" sx={{ml:5}}>
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              minHeight:"95vh",
              bgcolor: '#FFF',
              marginLeft:"15px",
              marginTop:"10px",
              borderRadius:"20px",
              boxShadow: "0px 10px 19px 1px #EAEAFF",
              '&:hover': {
                width: 225,
                webkitTransition: "width 1s ease-in-out",
                mozTransition: "width 1s ease-in-out",
                oTransition: "width 1s ease-in-out",
                transition: "width 1s ease-in-out",
              }
            }
          }}
          className={classes.customDrawer}
        >
          {renderContent}
        </Drawer>


        
      </MHidden>


      {/* <Drawer variant="permanent"   open={isOpenSidebar}
          onClose={onCloseSidebar}>

        {renderContent}

      </Drawer> */}

    </RootStyle>
  );
}
